import { combineReducers } from "redux";
import acquiredPropertiesReducer from "ducks/acquiredProperties/reducer";
import acquiredVehiclesReducer from "ducks/acquiredVehicles/reducer";
import businessCompleteSolutionsReducer from "ducks/businessCompleteSolution/reducer";
import creditCardReducer from "ducks/creditCards/reducer";
import depositRatesReducer from "ducks/depositRates/reducer";
import investmentReducer from "ducks/investment/reducer";
import dxpLanding from "ducks/dxpLanding/reducer";
import homeLoanRatesReducer from "ducks/homeLoanRates/reducer";
import homePageReducer from "ducks/homePage/reducer";
import navigationFooterReducer from "ducks/navigationAndFooter/reducer";
import personalLoanRatesReducer from "ducks/personalLoanRates/reducer";
import requestForCallbackReducer from "ducks/requestForCallback/reducer";
import timeDepositRatesReducer from "ducks/timeDepositRates/reducer";
import topBondPicksRatesReducer from "ducks/topBondPicks/reducer";
import otherServices from "ducks/otherServices/reducer";

const rootReducers = {
  acquiredPropertiesReducer,
  acquiredVehiclesReducer,
  businessCompleteSolutionsReducer,
  creditCardReducer,
  depositRatesReducer,
  dxpLanding,
  homeLoanRatesReducer,
  homePageReducer,
  investmentReducer,
  navigationFooterReducer,
  requestForCallbackReducer,
  personalLoanRatesReducer,
  timeDepositRatesReducer,
  topBondPicksRatesReducer,
  otherServices,
};

const combinedReducers = combineReducers(rootReducers);

export type RootReducerType = ReturnType<typeof combinedReducers>;
export default combinedReducers;
